import React from 'react';
import { DropTarget, DragElementWrapper } from 'react-dnd';

import * as Types from 'types';
import { DRAGGABLE_TYPES } from 'constants/global';
import { Trash } from 'playlists/components/Trash';

type Props = {
  isVisible: boolean;
  onDrop: (item: Types.PlaylistArtwork) => void;
};

const PlaylistArtworkTrash: React.FC<Props> = (props) => {
  const { isOver, canDrop, isVisible, connectDropTarget } = props as Props &
    CollectedProps;

  return connectDropTarget(
    <div
      style={{
        position: 'fixed',
        left: '16px',
        bottom: '44px',
        visibility: isVisible && canDrop ? 'visible' : 'hidden',
      }}
    >
      <Trash isOver={isOver} />
    </div>,
  );
};

type CollectedProps = {
  connectDropTarget: DragElementWrapper<any>;
  isOver: boolean;
  canDrop: boolean;
};

export const PlaylistArtworkTrashContainer = DropTarget<Props>(
  DRAGGABLE_TYPES.PLAYLIST_ARTWORK,
  {
    drop: (props, monitor) => {
      props.onDrop(monitor.getItem());
    },
  },
  (connect, monitor) => ({
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
    canDrop: monitor.canDrop(),
  }),
)(PlaylistArtworkTrash);
